<template>
<div class="wlx-site-manager-wrapper wlx-user-manager">
    <header class="site-manager-head-con" style="padding-top:20px;">
        <el-form :inline="true" size="small">
            <el-form-item>
                <el-input v-model="typeName" placeholder="请输入分类名称" clearable></el-input>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" icon="el-icon-search" @click="getCertificateTypeConfigList()">搜索</el-button>
                <el-button type="primary" icon="el-icon-circle-plus-outline" @click="addInfo">新增</el-button>
            </el-form-item>
        </el-form>
    </header>

    <div style="padding-left:30px;">
        <el-table :data="list">
            <el-table-column label="序号" type="index"></el-table-column>
            <el-table-column prop="typeName" label="分类名称"></el-table-column>
            <el-table-column prop="isScoreGrade" label="类型">
                <template slot-scope="scope">
                    <span v-if="scope.row.type==0">学生证书</span>
                    <span v-if="scope.row.type==1">师资证书</span>
                </template>
            </el-table-column>
            <el-table-column prop="configCount" label="配置证书数"></el-table-column>
            <el-table-column prop="orderNum" label="排序"></el-table-column>
            <el-table-column label="操作" width="300">
                <template slot-scope="scope">
                    <el-button size="mini" type="primary" @click="setGrade(scope.row)">设置分类</el-button>
                    <el-button size="mini" type="primary" @click="handleEdit(scope.row)">编辑</el-button>
                    <el-button size="mini" type="danger" @click="deleteInfo(scope.row.id)">删除</el-button>
                </template>
            </el-table-column>
        </el-table>

        <div class="u-page-con">
            <el-pagination background @size-change="handleSizeChange" @current-change="onPageChangeHandler" :current-page="page" :page-sizes="[10,20,50,100]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="totalCount" v-show="totalCount>0" style="text-align: center;"></el-pagination>
        </div>
    </div>

    <el-dialog title="编辑" :append-to-body="true" :visible.sync="dialogFormVisible" width="600px">
        <el-form :inline="true" :model="form" class="demo-form-inline" label-width="200px">
            <el-form-item label="证书类型">
                <el-input v-model="form.typeName"></el-input>
            </el-form-item>
           
            <el-form-item label="类型">
                <el-radio-group v-model="form.type">
                    <el-radio :label="0">学生证书</el-radio>
                    <el-radio :label="1">师资证书</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="排序">
                <el-input-number v-model="form.orderNum"></el-input-number>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button @click="cancelInfo">取 消</el-button>
            <el-button type="primary" @click="editInfo()">确 定</el-button>
        </div>
    </el-dialog>

    <el-dialog title="设置证书分类" :modal="false" :visible.sync="dialogGradeVisible" width="80%">
        <el-button type="primary" icon="el-icon-circle-plus-outline" @click="addGrade">新增</el-button>
        <el-table :data="gradeList">
            <el-table-column label="序号" type="index"></el-table-column>
            <el-table-column prop="certificateTypeName" label="证书名称"></el-table-column>
            <el-table-column prop="startYear" label="开始年份"></el-table-column>
            <el-table-column prop="endYear" label="截止年份"></el-table-column>
            <el-table-column prop="isTime" label="是否日期判断">
                <template slot-scope="scope">
                    <span v-if="scope.row.isTime == 0">否</span>
                    <span v-else-if="scope.row.isTime == 1">是</span>
                </template>
            </el-table-column>
            <el-table-column prop="orderNum" label="排序"></el-table-column>
            <el-table-column label="操作">
                <template slot-scope="scope">
                    <el-button size="mini" type="primary" @click="editGrade(scope.row)">编辑</el-button>
                    <el-button size="mini" type="danger" @click="deleteGrade(scope.row.id)">删除</el-button>
                </template>
            </el-table-column>
        </el-table>
    </el-dialog>

    <el-dialog title="编辑" :modal="false" :visible.sync="dialogGradeAddVisible" width="600px">
        <el-form :inline="true" :model="form" class="demo-form-inline" label-width="200px">
            <el-form-item label="证书类型">
                <!-- <el-input v-model="form.certificateTypeId"></el-input> -->
                <el-select v-model="form.certificateTypeId" placeholder="请选择" @change="typeChnage">
                    <el-option v-for="item in certificateTypeList" :key="item.value" :label="item.label" :value="item.value"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="是否日期判断">
                <!-- <el-input-number v-model="form.isTime"></el-input-number> -->
                <el-radio-group v-model="form.isTime">
                    <el-radio :label="1">是</el-radio>
                    <el-radio :label="0">否</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="开始年份" v-if="form.isTime==1">
                <el-input-number v-model="form.startYear"></el-input-number>
            </el-form-item>
            <el-form-item label="截止年份" v-if="form.isTime==1">
                <el-input-number v-model="form.endYear"></el-input-number>
            </el-form-item>
            
            <el-form-item label="排序">
                <el-input-number v-model="form.orderNum"></el-input-number>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button @click="dialogGradeAddVisible=false">取 消</el-button>
            <el-button type="primary" @click="editgrade()">确 定</el-button>
        </div>
    </el-dialog>
</div>
</template>

<script>
export default {
    data() {
        return {
            page: 1,
            pageSize: 10,
            totalCount: 0,
            typeName: "",
            isShowScore: "",
            isShowCertificate: "",
            form: {
                id: "",
                typeName: "",
                configId: "",
                certificateTypeId:"",
                startYear:0,
                endYear:0,
                IsTime:0,
                type:0,
                orderNum:0,
                hierarchy:0
            },
            dialogFormVisible: false,
            list: [],
            // 设置证书等级
            gradeList: [],
            typeId: "",
            dialogGradeVisible: false,
            dialogGradeAddVisible: false,
            gradeAddForm: {
                id: "",
                gradeName: ""
            },
            certificateTypeList:[]
        };
    },
    created() {
        this.getCertificateTypeConfigList();
    },
    methods: {
        getCertificateType(){
            var that = this;
            that.$http
            .post("/api/XOrg/CertificateTypeManager/getCertificateType", {
                type: this.form.type
            })
            .then(function (rst) {
                if (rst.code > 0) {
                    that.certificateTypeList = rst.list;
                } else {
                    that.$message.warning(rst.msg);
                }
            });

        },
        deleteGrade(id) {
            var that = this;
            this.$confirm("此操作将删除该数据, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
            }).then(() => {
                that.$http
                    .post("/api/XOrg/CertificateTypeConfigManager/deleteCertificateTypeConfig", {
                        ids: id
                    })
                    .then(function (rst) {
                        if (rst.code > 0) {
                            that.$message.success(rst.msg);
                            that.getGradeList();
                        } else {
                            that.$message.warning(rst.msg);
                        }
                    });
            });
        },
        editGrade(row) {
            this.form.id = row.id;
            this.form.typeName = row.typeName;
            // this.form.configId = row.configId;
            this.form.certificateTypeId = row.certificateTypeId;
            this.form.startYear = row.startYear;
            this.form.endYear = row.endYear;
            this.form.IsTime = row.IsTime;
            // this.form.type = row.type;
            this.form.orderNum = row.orderNum;
            this.form.hierarchy = row.hierarchy;
            this.dialogGradeAddVisible = true;
        },
        addGrade() {
            this.form.id = "";
            this.form.typeName = "";
            // this.form.configId = "";
            this.form.certificateTypeId = "";
            this.form.startYear = 0;
            this.form.endYear = 0;
            this.form.IsTime = 0;
            // this.form.type = 0;
            this.form.orderNum = 0;
            this.form.hierarchy = 1;
            this.dialogGradeAddVisible = true;
        },
        cancelAddGrade() {
            this.dialogGradeAddVisible = false;
            this.form.id = "";
            this.form.typeName = "";
            // this.form.configId = "";
            this.form.certificateTypeId = "";
            this.form.startYear = 0;
            this.form.endYear = 0;
            this.form.IsTime = 0;
            // this.form.type = 0;
            this.form.orderNum = 0;
            this.form.hierarchy = 1;
        },
        editgrade() {
            var that = this;
            debugger;
            this.$http
                .post("/api/XOrg/CertificateTypeConfigManager/addOrEditCertificateTypeConfig", {
                    id: this.form.id,
                    typeName: this.form.typeName,
                    configId: this.form.configId,
                    certificateTypeId: this.form.certificateTypeId,
                    startYear: this.form.startYear,
                    endYear: this.form.endYear,
                    isTime: this.form.isTime,
                    type: this.form.type,
                    orderNum: this.form.orderNum,
                    hierarchy: this.form.hierarchy
                })
                .then(function (rst) {
                    if (rst.code > 0) {
                        that.$message.success(rst.msg);
                        that.getGradeList();
                        that.cancelAddGrade();
                    } else {
                        that.$message.warning(rst.msg);
                    }
                });
        },
        //查询
        getGradeList() {
            var that = this;
            this.$http
                .post("/api/XOrg/CertificateTypeConfigManager/getCertificateTypeConfigList", {
                    typeName: this.typeName,
                    type:this.form.type,
                    configId: this.form.configId,
                    hierarchy: this.hierarchy,
                    PageSize: that.pageSize,
                    page: that.page
                })
                .then(function (rst) {
                    if (rst.code > 0) {
                        that.gradeList = rst.list;
                        // that.page = rst.pagination.pageIndex;
                        // that.pageSize = rst.pagination.pageSize;
                        // that.totalCount = rst.pagination.totalCount;
                    } else {
                        that.$message.warning(rst.msg);
                    }
                });
        },
        // 设置证书等级
        setGrade(row) {
            this.form.configId = row.id;
            this.form.type = row.type;
            this.form.hierarchy = 1;
            this.getGradeList();
            this.getCertificateType();
            this.dialogGradeVisible = true;
        },
        // 
        addOrEditCertificateTypeConfig() {
            var that = this;
            this.$http
                .post("/api/XOrg/CertificateTypeConfigManager/addOrEditCertificateTypeConfig", {
                    id: this.form.id,
                    typeName: this.form.typeName,
                    configId: this.form.configId,
                    certificateTypeId: this.form.certificateTypeId,
                    startYear: this.form.startYear,
                    endYear: this.form.endYear,
                    IsTime: this.form.IsTime,
                    type: this.form.type,
                    orderNum: this.form.orderNum,
                    hierarchy: this.form.hierarchy
                })
                .then(function (rst) {
                    if (rst.code > 0) {
                        that.gradeList = rst.list;
                    } else {
                        that.$message.warning(rst.msg);
                    }
                });
        },
        cancelInfo() {
            this.form.id = "";
            this.form.typeName = "";
            this.form.configId = "";
            this.form.certificateTypeId = "";
            this.form.startYear = 0;
            this.form.endYear = 0;
            this.form.IsTime = 0;
            this.form.type = 0;
            this.form.orderNum = 0;
            this.form.hierarchy = 0;
            this.dialogFormVisible = false;
        },
        addInfo() {
            this.dialogFormVisible = true;
        },
        //编辑
        editInfo() {
            var that = this;
            this.$http
                .post("/api/XOrg/CertificateTypeConfigManager/addOrEditCertificateTypeConfig", {
                    id: this.form.id,
                    typeName: this.form.typeName,
                    configId: this.form.configId,
                    certificateTypeId: this.form.certificateTypeId,
                    startYear: this.form.startYear,
                    endYear: this.form.endYear,
                    IsTime: this.form.IsTime,
                    type: this.form.type,
                    orderNum: this.form.orderNum,
                    hierarchy: this.form.hierarchy
                })
                .then(function (rst) {
                    if (rst.code > 0) {
                        that.$message.success(rst.msg);
                        that.cancelInfo();
                        that.getCertificateTypeConfigList();
                    } else {
                        that.$message.warning(rst.msg);
                    }
                });
        },
        //弹出框赋值
        handleEdit(row) {
            this.form.id = row.id;
            this.form.typeName = row.typeName;
            this.form.configId = row.configId;
            this.form.certificateTypeId = row.certificateTypeId;
            this.form.startYear = row.startYear;
            this.form.endYear = row.endYear;
            this.form.IsTime = row.IsTime;
            this.form.type = row.type;
            this.form.orderNum = row.orderNum;
            this.form.hierarchy = row.hierarchy;
            this.dialogFormVisible = true;
        },
        //删除
        deleteInfo(id) {
            var that = this;
            this.$confirm("此操作将删除该数据, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
            }).then(() => {
                that.$http
                    .post("/api/XOrg/CertificateTypeConfigManager/deleteCertificateTypeConfig", {
                        ids: id
                    })
                    .then(function (rst) {
                        if (rst.code > 0) {
                            that.$message.success(rst.msg);
                            that.getCertificateTypeConfigList();
                        } else {
                            that.$message.warning(rst.msg);
                        }
                    });
            });
        },
        //查询
        getCertificateTypeConfigList() {
            var that = this;
            this.$http
                .post("/api/XOrg/CertificateTypeConfigManager/getCertificateTypeConfigList", {
                    typeName: this.typeName,
                    type:this.form.type,
                    configId: this.form.configId,
                    hierarchy: this.form.hierarchy,
                    PageSize: that.pageSize,
                    page: that.page
                })
                .then(function (rst) {
                    if (rst.code > 0) {
                        that.list = rst.list;
                        that.page = rst.pagination.pageIndex;
                        that.pageSize = rst.pagination.pageSize;
                        that.totalCount = rst.pagination.totalCount;
                    } else {
                        that.$message.warning(rst.msg);
                    }
                });
        },
        handleSizeChange(val) {
            this.pageSize = val;
            this.getCertificateTypeConfigList();
        },
        onPageChangeHandler(val) {
            this.page = val;
            this.getCertificateTypeConfigList();
        }
    }
};
</script>

<style lang="scss">
.wlx-site-manager-wrapper {
    .demo-form-inline {
        .el-input__inner {
            width: 200px;
        }

        .img_upload {
            width: 500px;
        }
    }
}
</style>
